"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var react_redux_1 = require("react-redux");
var styled_components_1 = __importStar(require("styled-components"));
var components_1 = require("components");
var ConfigurationHeading_1 = __importDefault(require("./ConfigurationHeading"));
var api_1 = require("api");
var ItemDetails_1 = __importDefault(require("./ItemDetails"));
var react_intl_1 = require("react-intl");
var PreloadItems_1 = __importDefault(require("../PreloadItems"));
var ConflictDialog_1 = __importDefault(require("./ConflictDialog"));
var utils_1 = require("../utils");
var libzl_1 = require("../libzl");
var thumbnail_1 = require("../utils/thumbnail");
var accessoryNotVisibleTime = 2000; //ms
var desktopPanelWidth = 310;
var hiddenAccessoryGroups = (process.env.REACT_APP_HIDDEN_ACCESSORY_GROUPS || "").split(",");
var Container = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tposition: relative;\n\tdisplay: ", ";\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\twidth: 100%;\n\theight: 100%;\n\talign-items: stretch;\n\toverflow: hidden;\n"], ["\n\tposition: relative;\n\tdisplay: ", ";\n\tflex-direction: row;\n\tflex-wrap: nowrap;\n\twidth: 100%;\n\theight: 100%;\n\talign-items: stretch;\n\toverflow: hidden;\n"])), function (props) { return props.hide ? 'none' : 'flex'; });
var ExpandButton = styled_components_1.default(components_1.IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tsvg{\n\t\twidth: 24px;\n\t\theight: 100%;\n\t\tdisplay: block;\n\t\tmargin: auto;\n\t}\n"], ["\n\tsvg{\n\t\twidth: 24px;\n\t\theight: 100%;\n\t\tdisplay: block;\n\t\tmargin: auto;\n\t}\n"])));
var SideButton = styled_components_1.default(components_1.IconButton)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\t", ";\n\tfill: ", ";\n\tbackground-color: ", ";\n\t&:hover, &:focus {\n\t\t", "; \n\t}\n"], ["\n\t", ";\n\tfill: ", ";\n\tbackground-color: ", ";\n\t&:hover, &:focus {\n\t\t", "; \n\t}\n"])), function (props) { return props.theme.layout.sidebar.button; }, function (props) { return props.active ? props.theme.layout.sidebar.active : props.theme.layout.sidebar.inactive; }, function (props) { return props.active ? props.theme.layout.sidebar.activebgcol : "transparent"; }, function (props) { return !props.active ? "background-color:" + props.theme.layout.sidebar.hover : ""; });
var DesktopConfigurationRoot = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tpointer-events: all;\n\tz-index: 10;\n\t\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n\t\n\t", ";\n"], ["\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tpointer-events: all;\n\tz-index: 10;\n\t\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n\t\n\t", ";\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; }, function (props) { return props.theme.layout.sidebar.panel; });
var MobileConfigurationNav = styled_components_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tdisplay: none;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tdisplay: block;\n\t}\n"], ["\n\tdisplay: none;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tposition: absolute;\n\t\tbottom: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tdisplay: block;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var MobileFullScreenMenu = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tpointer-events: all;\n\tz-index: 150;\n\tbackground-color: white;\n\t\n\tdisplay: none;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: initial\n\t}\n"], ["\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n\tright: 0;\n\tpointer-events: all;\n\tz-index: 150;\n\tbackground-color: white;\n\t\n\tdisplay: none;\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: initial\n\t}\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; });
var MobileConfigurationExpand = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n\t", "\n\tposition: absolute;\n\ttop: -38px;\n\tright: 16px;\n\n\t& button {\n\t\twidth: 38px;\n\t\theight: 38px;\n\t\tpadding: 0px;\n\t\ttransform: rotate(90deg);\n\t}\n"], ["\n\t", "\n\tposition: absolute;\n\ttop: -38px;\n\tright: 16px;\n\n\t& button {\n\t\twidth: 38px;\n\t\theight: 38px;\n\t\tpadding: 0px;\n\t\ttransform: rotate(90deg);\n\t}\n"])), function (props) { return props.theme.breadcrumbs.backicon; });
var ListContainer = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n\theight: calc(100% - ", ")\n"], ["\n\theight: calc(100% - ", ")\n"])), function (props) { return props.showingSearch ? '108px' : '44px'; });
var CatImg = styled_components_1.default.img(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n\tmargin: 5px;\n\tborder-radius: 50%;\n\tborder: 2px solid ", ";\n\twidth: calc(100% - 14px);\n\theight: calc(100% - 14px);\n\tbackground-color: ", ";\n"], ["\n\tmargin: 5px;\n\tborder-radius: 50%;\n\tborder: 2px solid ", ";\n\twidth: calc(100% - 14px);\n\theight: calc(100% - 14px);\n\tbackground-color: ", ";\n"])), function (props) { return props.active ? props.theme.layout.sidebar.active : props.theme.layout.sidebar.hover; }, function (props) { return props.active ? props.theme.layout.sidebar.active : props.theme.layout.sidebar.inactive; });
var MobileConfiguration = styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n\tflex-shrink: 0;\n\t", ";\n"], ["\n\tflex-shrink: 0;\n\t", ";\n"])), function (props) { return props.theme.horizontalConfiguration.container; });
var SlideOutPanel = styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tright: ", "px;\n\twidth: ", "px;\n\tz-index: 5;\n\tpointer-events: all;\n\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: 0.5s right ease-in-out;\n\t}\n\n\twhite-space: nowrap;\n\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tright: ", ";\n\t\twidth: 100%;\n\t\ttransition: none;\n\t}\n\n\t", "\n"], ["\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tdisplay: none;\n\t}\n\n\tposition: absolute;\n\ttop: 0;\n\tbottom: 0;\n\tright: ", "px;\n\twidth: ", "px;\n\tz-index: 5;\n\tpointer-events: all;\n\n\t@media (prefers-reduced-motion: no-preference) {\n\t\ttransition: 0.5s right ease-in-out;\n\t}\n\n\twhite-space: nowrap;\n\n\t@media ", ", ", " and (orientation: portrait) {\n\t\tright: ", ";\n\t\twidth: 100%;\n\t\ttransition: none;\n\t}\n\n\t", "\n"])), function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; }, function (props) { return props.open ? 0 : -desktopPanelWidth; }, desktopPanelWidth, function (props) { return props.theme.breakpoints.S; }, function (props) { return props.theme.breakpoints.M; }, function (props) { return props.open ? 0 : 0; }, function (props) { return props.theme.layout.slideOutPanel; });
var noop = function () { };
var Configuration = /** @class */ (function (_super) {
    __extends(Configuration, _super);
    function Configuration(props) {
        var _this = _super.call(this, props) || this;
        _this.applyPreview = function () {
            if (_this.props.buildSession && window.zlurlparams.doPreview) {
                if (_this.state.previewing) {
                    if (!_this.itemVisible(_this.state.previewing).show) {
                        libzl_1.previewPrCodes(_this.props.buildSession, [], false, "");
                    }
                    else {
                        var codestopreview_1 = [_this.state.previewing.id];
                        var previewState = function (previewbs) {
                            _this.setState({ previewbs: previewbs });
                            var showPreviewEffect = true;
                            var isFeature = "";
                            if (_this.state.category.length > 0) {
                                var catId = _this.state.category[_this.state.category.length - 1].id;
                                // effect looks ugly for colours since the whole unit glows.
                                showPreviewEffect = catId !== "BRP_COLOR";
                                isFeature = catId.indexOf("BRP_") === 0 && codestopreview_1.length > 0 ? catId : "";
                                if (isFeature.length > 0) {
                                    for (var i = 0; i < codestopreview_1.length; i++) {
                                        //console.log("Pre san: ", isFeature, codestopreview[i]);
                                        codestopreview_1[i] = bs_1.sanitizeFeatureCode(isFeature, codestopreview_1[i]);
                                        //console.log("Post san: ", isFeature, codestopreview[i]);
                                    }
                                }
                            }
                            libzl_1.previewPrCodes(previewbs, codestopreview_1, showPreviewEffect, isFeature);
                        };
                        var autoresolve = function (details) {
                            details.resolutions[0].apply();
                        };
                        var bs_1 = _this.props.buildSession.clone(previewState, autoresolve, autoresolve, noop, true);
                        var item = bs_1.getOption(_this.state.previewing.id);
                        if (item.onAdd) {
                            item.onAdd();
                        }
                    }
                }
                else {
                    _this.clearPreview();
                }
            }
        };
        _this.clearPreview = function () {
            if (window.zlurlparams.doPreview) {
                if (_this.state.previewNotVisible !== undefined) {
                    clearTimeout(_this.state.previewNotVisible);
                }
                if (_this.props.buildSession) {
                    _this.setState({ previewing: null, previewbs: null });
                    libzl_1.previewPrCodes(_this.props.buildSession, [], false, "");
                }
            }
        };
        _this.navigatePush = function (category, clear) {
            _this.clearPreview();
            var notAtTopLevel = _this.state.category.length > 1;
            var onPushDone = function () {
                _this.props.onSizeChange(_this.state.category.length > 1 ? desktopPanelWidth : 0);
            };
            if (clear) {
                if (category.id !== api_1.ZL_ACCESSORIES && category.id !== api_1.ZL_OPTIONS) {
                    var stub = category.id.split("_");
                    var shortCatId = stub[stub.length - 1];
                    utils_1.ZLTagger.UC02_categorytool(shortCatId, shortCatId);
                }
            }
            if (clear && notAtTopLevel) {
                // going to a new top level, clear the stack
                _this.setState(function (state) { return (__assign(__assign({}, state), { prevCategory: __spreadArrays(state.category), category: state.category.slice(0, 1).concat(category), preloadImages: true })); }, onPushDone);
            }
            else {
                _this.setState(function (state) { return (__assign(__assign({}, state), { prevCategory: __spreadArrays(state.category), category: state.category.concat(category), preloadImages: true })); }, onPushDone);
            }
        };
        _this.navigateTop = function () {
            _this.navigatePop("");
            _this.collapseMobile();
        };
        _this.navigatePop = function (categoryId) {
            _this.clearPreview();
            _this.setState(function (state) { return (__assign(__assign({}, state), { prevCategory: __spreadArrays(state.category), category: state.category.slice(0, state.category.findIndex(function (category) { return category.id === categoryId; }) + 1), highlighted: null })); }, function () {
                _this.props.onSizeChange(_this.state.category.length > 1 ? desktopPanelWidth : 0);
            });
        };
        _this.showDetails = function (item) {
            _this.setState({ showDetails: item });
        };
        _this.hideDetails = function () {
            _this.setState({ showDetails: null });
        };
        _this.getItemName = function (item, s) {
            if (item.id === api_1.ZL_ACCESSORIES) {
                return s("summary.accessories", "Accessories");
            }
            else if (item.id === api_1.ZL_OPTIONS) {
                return s("configuration.options", "Options");
            }
            return item.name;
        };
        _this.getDefaultRootIcon = function (item, active) {
            switch (item.id) {
                case api_1.ZL_ACCESSORIES: {
                    return _this.props.theme.svgs.icon_accessories;
                }
                case api_1.ZL_OPTIONS: {
                    return _this.props.theme.svgs.icon_options;
                }
                default: {
                    var icon = undefined;
                    if (_this.props.buildSession) {
                        var thumb = libzl_1.getItemThumb(_this.props.buildSession, _this.props.buildSession.getFeatureCode(item.id), item.id, _this.props.theme.svgs);
                        icon = thumb.icon || thumb.fallback;
                    }
                    if (icon) {
                        if (typeof (icon) === "string") {
                            return (react_1.default.createElement(CatImg, { active: active, src: icon, alt: item.name }));
                        }
                        return icon;
                    }
                    return _this.props.theme.svgs.icon_color;
                }
            }
        };
        _this.renderRoots = function (items, s, currentCategory) {
            var atTopLevel = _this.state.category.length <= 1;
            return items.map(function (item) {
                return (react_1.default.createElement(components_1.Badge, { disabled: !_this.props.apiready, key: item.id, count: item.onClick ? 0 : (item.selected || 0) },
                    react_1.default.createElement(SideButton, { key: item.id, name: _this.getItemName(item, s), showName: true, icon: item.icon || _this.getDefaultRootIcon(item, item.id === currentCategory && !atTopLevel), active: item.id === currentCategory && !atTopLevel, onClick: function () { return _this.state.category.find(function (i) { return i.id === item.id; }) ? _this.navigateTop() : _this.navigatePush(item, true); }, automationId: "option-" + item.id, taggingOverride: "notag", disabled: !_this.props.apiready })));
            });
        };
        _this.filterItems = function (items, catId) {
            return items.filter(function (item) {
                if (!window.zlurlparams.onlyvis || (catId && catId.indexOf("BRP_") === 0)) {
                    return !hiddenAccessoryGroups.includes(item.id);
                }
                return item.onClick === undefined || libzl_1.isCodeVisual(item.id).show !== false;
            }).filter(function (item) {
                var _a;
                var accCat = item.onClick === undefined;
                if (accCat) {
                    if (item.name.length === 0 || (window.zlurlparams.onlyvis && item.validAttachPoints && !item.validAttachPoints.some(function (code) { return libzl_1.isCodeVisual(code).show !== false; }))) {
                        console.warn("Filtered out bad category: ", item.id);
                        return false;
                    }
                    if (_this.state.skuFilter && !((_a = item.validAttachPoints) === null || _a === void 0 ? void 0 : _a.some(function (code) { return code.includes(_this.state.skuFilter.trim()); }))) {
                        return false;
                    }
                }
                else {
                    if (item.price === undefined && !window.zlurlparams.hideprices && !item.locked) {
                        console.warn("Filtered out item with no price: ", item);
                        return false;
                    }
                    if (!item.name && !window.zlurlparams.allowmissingnames) {
                        console.warn("Filtered out item with no name: ", item);
                        return false;
                    }
                    if (_this.state.skuFilter && !item.id.includes(_this.state.skuFilter.trim())) {
                        return false;
                    }
                }
                return true;
            });
        };
        _this.renderItems = function (items, s, catId) {
            var add = s("configuration.add", "Add");
            var remove = s("configuration.remove", "Remove");
            var removeAll = s("configuration.removeall", "Remove All");
            var edit = s("configuration.edit", "Edit");
            var close = s("configuration.close", "Close");
            var moreinfo = s("configuration.details", "Details");
            var quantity = s("configuration.quantity", "QUANTITY");
            var nopreview = s("item.noicon", "no image");
            var preview = s("item.previewing", "PREVIEW");
            var highlighted = _this.state.highlighted;
            return _this.filterItems(items, catId).map(function (item) {
                var itemVisibility = _this.itemVisible(item);
                var renderable = itemVisibility.show ? itemVisibility.show : false;
                var blacklisted3D = itemVisibility.bl3d ? itemVisibility.bl3d : false;
                var blacklistedUI = itemVisibility.blui ? itemVisibility.blui : false;
                var onHighlight = noop;
                var onClick = noop;
                var onInfo = undefined;
                var accCat = item.onClick === undefined;
                //let accCatId = this.state.category.length > 2 ? this.state.category[this.state.category.length-1].id : "";
                if (accCat) {
                    if (_this.state.highlighted !== item) {
                        onHighlight = function () {
                            _this.setState({ highlighted: item });
                        };
                    }
                    onClick = function () {
                        if (item.id !== api_1.ZL_ACCESSORIES && item.id !== api_1.ZL_OPTIONS) {
                            var cat = item.id;
                            if (catId === api_1.ZL_ACCESSORIES) {
                                cat = "accessory";
                            }
                            utils_1.ZLTagger.UC02_categorytool(cat, item.name);
                        }
                        _this.navigatePush(item);
                    };
                }
                else {
                    if (window.zlurlparams.doPreview) {
                        onHighlight = function () {
                            if (_this.state.previewNotVisible !== undefined) {
                                clearTimeout(_this.state.previewNotVisible);
                            }
                            var previewNotVisible = undefined;
                            if (!renderable && item.deselectable) {
                                previewNotVisible = setTimeout(function () {
                                    _this.setState({ previewNotVisible: undefined });
                                }, accessoryNotVisibleTime);
                            }
                            _this.setState({ highlighted: item, previewing: item.selected === 0 ? item : null, previewNotVisible: previewNotVisible, mobileFull: false }, function () {
                                _this.applyPreview();
                            });
                        };
                        if (window.matchMedia && window.matchMedia("screen and (pointer: coarse)").matches) {
                            onClick = onHighlight;
                            onHighlight = noop;
                        }
                    }
                    else {
                        onClick = function () {
                            _this.setState({ highlighted: item });
                            if (item.selected === 0) {
                                if (item.onAdd) {
                                    item.onAdd(item.selected === 0 ? undefined : 0);
                                }
                            }
                            else { // if(!item.attachedPoints || item.attachedPoints.length < (item.selected || 0)) {
                                if (item.onAttach) {
                                    item.onAttach();
                                }
                            }
                            /*
                            else if(item.attachedPoints && item.attachedPoints.length > 0 && !item.locked) {
                                if(item.onDetach) {
                                    item.onDetach();
                                }
                            }
                            */
                        };
                    }
                    if (item.deselectable) {
                        onInfo = function () { return _this.showDetails(item); };
                    }
                }
                var onLowlight = function () {
                    _this.setState({ highlighted: null, previewing: null }, _this.clearPreview);
                };
                var isHighlighted = (highlighted !== null && highlighted.id === item.id);
                accCat = accCat && item.categoryId !== api_1.ZL_OPTIONS;
                var thumbnail = thumbnail_1.getThumbnail(_this.props.buildSession, item.icon, item.id, item.categoryId, accCat, isHighlighted, renderable, item.deselectable !== undefined, nopreview, _this.props.theme.svgs, item.validTo, item.validFrom, blacklisted3D, blacklistedUI, item.validAttachPoints);
                return (react_1.default.createElement(components_1.ConfigurationOption, { key: item.id, id: item.id, name: _this.getItemName(item, s), price: window.zlurlparams.hideprices ? undefined : item.price, thumbnail: thumbnail, deselectable: item.deselectable, selected: item.selected || 0, included: item.locked, includedMessage: s("item.includedinpackage", "{count} Included in Package", { count: item.locked }), preview: preview, previewing: (renderable === true && _this.state.previewing && _this.state.previewing.id === item.id) || false, unavailable: item.deselectable && !item.price && !window.zlurlparams.hideprices, maximum: item.maximum, renderable: renderable, highlighted: isHighlighted, onHighlight: onHighlight, onLowlight: onLowlight, onClick: onClick, add: add, onAdd: item.onAdd || noop, remove: remove, onRemove: item.onRemove || noop, removeAll: removeAll, edit: edit, close: close, quantityLabel: quantity, info: onInfo && moreinfo, onInfo: onInfo, automationId: "option-" + item.id }));
            });
        };
        _this.expandMobile = function () {
            _this.setState({ mobileFull: true });
        };
        _this.collapseMobile = function () {
            _this.setState({ mobileFull: false });
        };
        _this.willRenderSearch = function () {
            return window.zlurlparams.showsearch && _this.state.category.some(function (i) { return i.id === api_1.ZL_ACCESSORIES; });
        };
        _this.renderSearch = function () {
            if (_this.willRenderSearch()) {
                return (react_1.default.createElement("div", { style: { paddingLeft: 20, paddingRight: 20, marginTop: -30, marginBottom: -20, display: "flex" } },
                    react_1.default.createElement(components_1.TextField, { label: "SKU", defaultValue: _this.state.skuFilter, onChange: function (v) { return _this.setState({ skuFilter: v }); } })));
            }
            return null;
        };
        _this.state = {
            category: [{ id: "", name: "Categories" }],
            prevCategory: [{ id: "", name: "Categories" }],
            highlighted: null,
            showDetails: null,
            preloadImages: props.connected,
            previewing: null,
            previewbs: null,
            previewNotVisible: undefined,
            mobileFull: false,
            skuFilter: ""
        };
        _this.preloadtimer = null;
        _this.streamContainer = null;
        return _this;
    }
    Configuration.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        if (!prevProps.connected && this.props.connected) {
            // stream is done connecting so start the image preloading (postpone slightly so stuff like the camera thumbs get requested first)
            this.preloadtimer = setTimeout(function () { return _this.setState({ preloadImages: true }); }, 100);
        }
        if (!window.zlurlparams.doPreview && prevProps.summary !== this.props.summary) {
            if (this.props.summary && this.props.summary.action === api_1.Action.AddedAccessory) {
                if (this.state.previewNotVisible !== undefined) {
                    clearTimeout(this.state.previewNotVisible);
                }
                var previewNotVisible = undefined;
                var item = this.props.summary.item;
                if (this.itemVisible(item).show === false) {
                    previewNotVisible = setTimeout(function () {
                        _this.setState({ previewNotVisible: undefined });
                    }, accessoryNotVisibleTime);
                }
                this.setState({ previewNotVisible: previewNotVisible });
            }
        }
    };
    Configuration.prototype.componentWillUnmount = function () {
        if (this.preloadtimer) {
            clearTimeout(this.preloadtimer);
        }
    };
    Configuration.prototype.itemVisible = function (item) {
        var rootDetails = libzl_1.isCodeVisual(item.id);
        if (item.displayable !== false) {
            if (rootDetails.show) {
                return rootDetails;
            }
            for (var _i = 0, _a = (item.contains || []); _i < _a.length; _i++) {
                var code = _a[_i];
                var details = libzl_1.isCodeVisual(code);
                if (details.show) {
                    return details;
                }
            }
        }
        return __assign(__assign({}, rootDetails), { show: false });
    };
    Configuration.prototype.renderPreviewNotVisible = function (s) {
        if ((!this.state.previewing && window.zlurlparams.doPreview) || this.state.previewNotVisible === undefined) {
            return null;
        }
        if (!this.streamContainer) {
            this.streamContainer = document.getElementById("streamContainer");
            if (!this.streamContainer) {
                return null;
            }
        }
        return react_dom_1.default.createPortal(react_1.default.createElement(components_1.Message, { automationId: "accessory_not_visible" }, s("configuration.nopreview", "ACCESSORY NOT VISIBLE")), this.streamContainer);
    };
    Configuration.prototype.render = function () {
        var _this = this;
        var s = function (id, defaultStr, params) {
            return utils_1.formatMessage(_this.props.intl, { id: id, defaultMessage: defaultStr ? defaultStr : id }, params ? params : {});
        };
        var rootCategory = this.state.category[0];
        var rootOptions = [];
        if (this.props.buildSession) {
            rootOptions = this.props.buildSession.getOptions(rootCategory ? rootCategory.id : undefined);
        }
        var currentCategories = this.state.category.length > 1 ? this.state.category : this.state.prevCategory;
        currentCategories = currentCategories.map(function (c) { return ({ id: c.id, name: _this.getItemName(c, s) }); });
        var fromEnd = 1;
        var currentCategory = currentCategories[currentCategories.length - fromEnd];
        var rootHighlightCategory = currentCategory;
        if (rootHighlightCategory.id.indexOf("BRP_") < 0) {
            while (rootHighlightCategory.id !== api_1.ZL_ACCESSORIES && rootHighlightCategory.id !== api_1.ZL_OPTIONS && fromEnd < currentCategories.length - 1) {
                rootHighlightCategory = currentCategories[currentCategories.length - ++fromEnd];
            }
        }
        var catId = currentCategory ? currentCategory.id : undefined;
        var items = [];
        if (this.props.buildSession) {
            items = this.props.buildSession.getOptions(catId);
        }
        var labels = {
            prevLabel: s("configuration.scroll_left", "Previous"),
            nextLabel: s("configuration.scroll_right", "Next")
        };
        var initialFocusIndex = undefined;
        if (this.state.prevCategory.length > this.state.category.length) {
            var filteredItems = this.filterItems(items, catId);
            initialFocusIndex = filteredItems.findIndex(function (i) { return i.id === _this.state.prevCategory[_this.state.prevCategory.length - 1].id; });
        }
        else if (this.state.highlighted !== null) {
            var filteredItems = this.filterItems(items, catId);
            var highlighted_1 = this.state.highlighted.id;
            initialFocusIndex = filteredItems.findIndex(function (i) { return i.id === highlighted_1; });
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Container, { hide: this.props.hide },
                react_1.default.createElement("div", { style: { flexGrow: 1 } }, this.props.children),
                this.props.buildSession &&
                    react_1.default.createElement(react_1.default.Fragment, null,
                        react_1.default.createElement("div", { id: "SlideOut", style: { width: 0, position: 'relative', pointerEvents: 'all' } },
                            react_1.default.createElement(SlideOutPanel, { open: this.state.category.length > 1 }, this.state.category.length > 1 &&
                                react_1.default.createElement(react_1.default.Fragment, null,
                                    this.renderSearch(),
                                    react_1.default.createElement(ConfigurationHeading_1.default, { crumbs: currentCategories, onClickBack: this.navigatePop, onClickClose: this.navigateTop }),
                                    react_1.default.createElement(ListContainer, { showingSearch: this.willRenderSearch() },
                                        react_1.default.createElement(components_1.VerticalList, { key: this.state.category.length, prevLabel: "", nextLabel: "", initialFocusIndex: initialFocusIndex }, this.renderItems(items, s, catId)))))),
                        this.state.mobileFull &&
                            react_1.default.createElement(MobileFullScreenMenu, null,
                                this.renderSearch(),
                                react_1.default.createElement(ConfigurationHeading_1.default, { crumbs: currentCategories, onClickBack: this.navigatePop, onClickClose: this.collapseMobile }),
                                react_1.default.createElement(ListContainer, { showingSearch: this.willRenderSearch() },
                                    react_1.default.createElement(components_1.VerticalList, { key: this.state.category.length, prevLabel: "", nextLabel: "", initialFocusIndex: initialFocusIndex }, this.renderItems(items, s, catId)))),
                        react_1.default.createElement(DesktopConfigurationRoot, { id: "DesktopConfigurationRoot" }, this.renderRoots(rootOptions, s, rootHighlightCategory.id)),
                        !this.state.mobileFull &&
                            react_1.default.createElement(MobileConfigurationNav, { id: "MobileConfigurationNav" }, this.state.category.length > 1 &&
                                react_1.default.createElement("div", { style: { padding: "8px" } },
                                    react_1.default.createElement(components_1.Breadcrumbs, { crumbs: currentCategories, onClick: this.navigatePop, backMsg: s("breadcrumbs.back", "Back") }))))),
            this.props.buildSession &&
                react_1.default.createElement(react_1.default.Fragment, null,
                    !this.state.mobileFull &&
                        react_1.default.createElement(MobileConfiguration, { id: "MobileConfiguration", hide: this.props.hide },
                            this.state.category.length === 1 ?
                                react_1.default.createElement(components_1.HorizontalList, __assign({ key: rootOptions.length + (this.props.hide ? "h" : "") }, labels), this.renderRoots(rootOptions, s, rootHighlightCategory.id))
                                :
                                    react_1.default.createElement(components_1.HorizontalList, __assign({ key: this.state.category.length + (this.props.hide ? "h" : ""), initialFocusIndex: initialFocusIndex }, labels), this.renderItems(items, s, catId)),
                            this.state.category.length > 1 &&
                                react_1.default.createElement(MobileConfigurationExpand, null,
                                    react_1.default.createElement(ExpandButton, { onClick: this.expandMobile, automationId: "expand", name: "Expand menu", small: true, icon: this.props.theme.svgs.scroll_up }))),
                    this.renderPreviewNotVisible(s),
                    this.state.preloadImages &&
                        react_1.default.createElement(PreloadItems_1.default, null) /* do after the menu so top level items get queued first*/,
                    this.state.showDetails && react_1.default.createElement(ItemDetails_1.default, { category: this.state.category, defaultItemId: this.state.showDetails.id, onClose: this.hideDetails }),
                    react_1.default.createElement(ConflictDialog_1.default, null))));
    };
    return Configuration;
}(react_1.Component));
var MapStoreToProps = function (store /*, ownProps:any*/) {
    return {
        buildSession: store.BuildSession.current,
        summary: store.BuildSession.summary
    };
};
exports.default = react_redux_1.connect(MapStoreToProps)(styled_components_1.withTheme(react_intl_1.injectIntl(Configuration)));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;
//# sourceMappingURL=Configuration.js.map